import * as React from "react";
import { useState } from "react";
import { Grid, InputAdornment, ListSubheader, TextField, useMediaQuery, useTheme } from "@mui/material";
import { useColors } from "../../../../Context/ColorsContext";

// Component Date
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/de';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Box from "@mui/material/Box";

// Multi Select
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";

import { useTranslation } from "react-i18next";

import {
  CleanIcon,
  CustomToolbar,
  CustomFormControl,
  ContainerInputsDate,
  CustomInputLabel,
  CustomMenuItem,
  CustomBadge,
  ContainerSwitch,
  LabelSwitch,
  CleanButton,
} from "./styles";

import { Forms, CustomButtonV2, CustomSelectDemo, AntSwitch } from "../../../../pages/styles";
import { Search } from "@mui/icons-material";

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from "../../../../Context/PermissionsContext";


export function TableToolbarWorkflow(props) {

  const {
    arrayCombined,
    filterPlants,
    filterCompany,
    hideFlowBtn,
    handleChangeFilters,
    handleFilters,
    filters,
    handleClearFilters,
    handleCreateWorkflow,
    finalDate,
    initialDate,
    workflow,
    isLotoWorkflow,
  } = props;

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;

  const { t } = useTranslation();
  const ability = useAbility(AbilityContext);
  const { colors } = useColors();
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [searchPlantText, setSearchPlantText] = useState("");
  const [searchStatusText, setSearchStatusText] = useState("");
  const [searchCompanyText, setSearchCompanyText] = useState("");

  const containsText = (text, search) => text?.toLowerCase().indexOf(search.toLowerCase()) > -1;

  const [showScrollIndicator, setShowScrollIndicator] = useState(true);

  const handleScroll = (e) => {
    const { scrollLeft, scrollWidth, clientWidth } = e.target;
    // Hide indicator if the user scrolled to the end (allow 2px margin of error)
    if (scrollLeft + clientWidth >= scrollWidth - 2) {
      setShowScrollIndicator(false);
    } else {
      setShowScrollIndicator(true);
    }
  };

  const optionsPlants = React.useMemo(() => filterPlants?.filter((option) => containsText(option.name, searchPlantText)) || [],
    [filterPlants, searchPlantText]);

  const optionsStatus = React.useMemo(() => arrayCombined?.filter((option) => containsText(option.title, searchStatusText)) || [],
    [arrayCombined, searchStatusText]);

  const optionsCompany = React.useMemo(() => filterCompany?.filter((option) => containsText(option.name, searchCompanyText)) || [],
    [filterCompany, searchCompanyText]);

  const MenuPropsSelect = (needAuto) => {

    const MenuProps = {
      autoFocus: false,
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: needAuto ? 'auto' : 250,
          left: needAuto && 1500
        },
      },
    };

    return MenuProps;
  }

  const renderCreateFlowButton = () => {
    if (isLotoWorkflow || !(handleCreateWorkflow && hideFlowBtn !== false)) return null;
    return (
      <CustomButtonV2
        variant="contained"
        onClick={handleCreateWorkflow}
        startIcon={<AddCircleOutlineIcon />}
        btnType={isTablet ? "" : "primary"}
        sx={{
          visibility: hideFlowBtn === false ? 'hidden' : 'visible',
          whiteSpace: 'nowrap',
					width: isMobile ? '60%' : '100%',
        }}
      >
        {t("workflow.initFlow")}
      </CustomButtonV2>
    );
  };

  const renderOnlyActiveSwitch = () => {
    if (isLotoWorkflow || !workflow.hasOnlyActiveFilter) return null;
    return (
      <ContainerSwitch sx={{ padding: '0px 2px' }}>
        <LabelSwitch style={{ marginBottom: 0, marginRight: '3px' }}>
          {t("common.onlyActive")}
        </LabelSwitch>
        <AntSwitch
          checked={filters?.onlyActive}
          id="filter-status-onlyactive"
          onChange={e => handleChangeFilters(e, "onlyActive", "checkbox")}
          size="small"
        />
      </ContainerSwitch>
    );
  };

  const renderStatusCanceledSwitch = () => {
    if (!(ability.can("WorkflowStatusList") || ability.can("WorkflowStatusStandardList"))) return null;
    return (
      <ContainerSwitch>
        <LabelSwitch style={{ marginBottom: 0, marginRight: '8px' }}>
          {t("common.statusCanceledFilter")}
        </LabelSwitch>
        <AntSwitch
          checked={filters?.includeCanceled}
          id="filter-status-canceled"
          onChange={e => handleChangeFilters(e, "includeCanceled", "checkbox")}
          size="small"
        />
      </ContainerSwitch>
    );
  };

  const renderStatusClosedSwitch = () => {
    if (!(ability.can("WorkflowStatusList") || ability.can("WorkflowStatusStandardList"))) return null;
    return (
      <ContainerSwitch>
        <LabelSwitch style={{ marginBottom: 0, marginRight: '8px' }}>
          {t("common.statusClosedFilter")}
        </LabelSwitch>
        <AntSwitch
          id="filter-status-closed"
          checked={filters?.includeClosed}
          onChange={e => handleChangeFilters(e, "includeClosed", "checkbox")}
          size="small"
        />
      </ContainerSwitch>
    );
  };

  const renderPlantsFilter = () => {
    if (isLotoWorkflow || !ability.can("PlantList")) return null;
    return (
      <CustomFormControl>
        <CustomInputLabel id="filter-plants">
          {isTablet ? t("common.shortPlantsFilter") : t("common.plantsFilter")}
        </CustomInputLabel>
        <CustomBadge badgeContent={filters?.plants?.length} color="primary" sx={{ color: "white" }}>
          <CustomSelectDemo
            labelId="filter-plants"
            id="filter-plants-select"
            multiple
            value={filters?.plants || []}
            onChange={e => handleChangeFilters(e, "plants", "select")}
            onClose={() => setSearchPlantText("")}
            renderValue={() => ""}
            MenuProps={MenuPropsSelect(false)}
          >
            <ListSubheader>
              <TextField
                size="small"
                autoFocus
                placeholder={t("common.search")}
                fullWidth
                InputProps={{ startAdornment: (<InputAdornment position="start"><Search /></InputAdornment>) }}
                onChange={(e) => setSearchPlantText(e.target.value)}
                onKeyDown={(e) => { if (e.key !== "Escape") e.stopPropagation(); }}
              />
            </ListSubheader>
            {optionsPlants.slice().sort((a, b) => a.name.localeCompare(b.name)).map((tag) => (
              <CustomMenuItem key={tag.id} value={tag} sx={{ fontSize: "0.6em" }}>
                <Checkbox checked={filters?.plants?.indexOf(tag) > -1} sx={{ width: "30px", height: "30px" }} />
                <ListItemText primary={tag.name} />
              </CustomMenuItem>
            ))}
          </CustomSelectDemo>
        </CustomBadge>
      </CustomFormControl>
    );
  };

  const renderStatusFilter = () => {
    if (isLotoWorkflow || !(ability.can("WorkflowStatusList") || ability.can("WorkflowStatusStandardList"))) return null;
    return (
      <CustomFormControl>
        <CustomInputLabel id="filter-status">
          {isTablet ? t("common.shortStatusFilter") : t("common.statusFilter")}
        </CustomInputLabel>
        <CustomBadge badgeContent={filters?.status?.length} color="primary" sx={{ color: "white" }}>
          <CustomSelectDemo
            labelId="filter-status"
            id="demo-multiple-checkbox"
            multiple
            value={filters?.status || []}
            onChange={e => handleChangeFilters(e, "status", "select")}
            onClose={() => setSearchStatusText("")}
            renderValue={() => ""}
            MenuProps={MenuPropsSelect(true)}
          >
            <ListSubheader>
              <TextField
                size="small"
                autoFocus
                placeholder={t("common.search")}
                fullWidth
                InputProps={{ startAdornment: (<InputAdornment position="start"><Search /></InputAdornment>) }}
                onChange={(e) => setSearchStatusText(e.target.value)}
                onKeyDown={(e) => { if (e.key !== "Escape") e.stopPropagation(); }}
              />
            </ListSubheader>
            {optionsStatus.slice().map((tag) => (
              <CustomMenuItem key={tag.id} value={tag} sx={{ fontSize: "0.6em" }}>
                <Checkbox checked={filters?.status?.indexOf(tag) > -1} sx={{ width: "30px", height: "30px" }} />
                <ListItemText primary={tag.title} />
              </CustomMenuItem>
            ))}
          </CustomSelectDemo>
        </CustomBadge>
      </CustomFormControl>
    );
  };

  const renderCompanyFilter = () => {
    if (isLotoWorkflow) return null;
    return (
      <CustomFormControl>
        <CustomInputLabel id="filter-company">
          {t("common.company")}
        </CustomInputLabel>
        <CustomBadge badgeContent={filters?.company?.length} color="primary" sx={{ color: "white" }}>
          <CustomSelectDemo
            labelId="filter-company"
            id="demo-multiple-checkbox"
            multiple
            value={filters?.company || []}
            onChange={e => handleChangeFilters(e, "company", "select")}
            onClose={() => setSearchCompanyText("")}
            renderValue={() => ""}
            MenuProps={MenuPropsSelect(true)}
          >
            <ListSubheader>
              <TextField
                size="small"
                autoFocus
                placeholder={t("common.search")}
                fullWidth
                InputProps={{ startAdornment: (<InputAdornment position="start"><Search /></InputAdornment>) }}
                onChange={(e) => setSearchCompanyText(e.target.value)}
                onKeyDown={(e) => { if (e.key !== "Escape") e.stopPropagation(); }}
              />
            </ListSubheader>
            {optionsCompany.slice().sort((a, b) => a.name.localeCompare(b.name)).map((tag) => (
              <CustomMenuItem key={tag.id} value={tag} sx={{ fontSize: "0.6em" }}>
                <Checkbox checked={filters?.company?.indexOf(tag) > -1} sx={{ width: "30px", height: "30px" }} />
                <ListItemText primary={tag.name} />
              </CustomMenuItem>
            ))}
          </CustomSelectDemo>
        </CustomBadge>
      </CustomFormControl>
    );
  };

  const renderStartDateFilter = () => {
    if (isLotoWorkflow) return null;
    return (
      <ContainerInputsDate>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
          <DatePicker
            label={isTablet ? t("common.from") : t("common.initDate")}
            value={filters?.startDate ? moment(filters.startDate) : null}
            minDate={moment('2020-03-20')}
            maxDate={moment(finalDate)}
            onChange={e => handleChangeFilters(e || "", "startDate", "date")}
            slotProps={{ textField: { size: 'small', error: false, sx: { minWidth: '100%', width: '100%' } } }}
            format="DD/MM/YYYY"
          />
        </LocalizationProvider>
      </ContainerInputsDate>
    );
  };

  const renderEndDateFilter = () => {
    if (isLotoWorkflow) return null;
    return (
      <ContainerInputsDate>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
          <DatePicker
            label={isTablet ? t("common.to") : t("common.lastDate")}
            value={filters?.endDate ? moment(filters.endDate) : null}
            minDate={moment(initialDate)}
            onChange={(e) => handleChangeFilters(e || "", "endDate", "date")}
            slotProps={{ textField: { size: 'small', error: false, sx: { minWidth: '100%', width: '100%' } } }}
            format="DD/MM/YYYY"
          />
        </LocalizationProvider>
      </ContainerInputsDate>
    );
  };

  const renderSearchAndCleanButtons = () => {
    return (
      <div style={{ display: "flex", flexDirection: "row", gap: 6, width: "100%" }}>
        <CustomButtonV2 
          variant="contained"
          btnType="primary"
          type="submit"
          startIcon={<SearchIcon />}
          sx={{ flexGrow: isMobile ? 1 : 0 }}
        >
          {t("common.search")}
        </CustomButtonV2>
        <CleanButton
          startIcon={<CleanIcon />}
          onClick={handleClearFilters}
          sx={{ flexGrow: isMobile ? 1 : 0 }}
        >
          {t("common.clean")}
        </CleanButton>
      </div>
    );
  };

  const applyFilters = async () => {
    await handleFilters();
  }

  return (
    <CustomToolbar>
      <Forms
        onSubmit={e => {
          e.preventDefault()
          applyFilters()
        }}
        style={{ justifyContent: 'flex-start', flexWrap: 'wrap', width: '100%' }}
      >
        {isTablet ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
            {/* Fila 1: Componentes desplazables horizontalmente con indicador de scroll al final */}
            <Box sx={{ position: 'relative', width: '100%' }}>
              <Box
                onScroll={handleScroll}
                sx={{
                  pt: { xs: isLotoWorkflow ? 0 : 2, md: 0 },
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 1,
                  overflowX: 'auto',
                  overflowY: 'hidden',
                  pb: 1, // Espacio para la barra de desplazamiento
                  '&::-webkit-scrollbar': {
                    height: '6px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,.2)',
                    borderRadius: '3px',
                  }
                }}
              >
                {renderPlantsFilter() && 
                  <Box sx={{ minWidth: '120px' }}>
                    {renderPlantsFilter()}
                  </Box>
                }
                {renderStatusFilter() && 
                  <Box sx={{ minWidth: '120px' }}>
                    {renderStatusFilter()}
                  </Box>
                }
                {renderCompanyFilter() &&
                  <Box sx={{ minWidth: '120px' }}>
                    {renderCompanyFilter()}
                  </Box>
                }
                {!isLotoWorkflow && renderStatusCanceledSwitch() && 
                  <Box sx={{ minWidth: '120px', display: 'flex', alignItems: 'center' }}>
                    {renderStatusCanceledSwitch()}
                  </Box>
                }
                {!isLotoWorkflow && renderStatusClosedSwitch() && 
                  <Box sx={{ minWidth: '120px', display: 'flex', alignItems: 'center' }}>
                    {renderStatusClosedSwitch()}
                  </Box>
                }
                {renderOnlyActiveSwitch() && 
                  <Box sx={{ minWidth: '120px', display: 'flex', alignItems: 'center' }}>
                    {renderOnlyActiveSwitch()}
                  </Box>
                }
                {renderStartDateFilter() &&
                  <Box sx={{ minWidth: '120px', display: 'flex', alignItems: 'center' }}>
                    {renderStartDateFilter()}
                  </Box>
                }
                {renderEndDateFilter() &&
                  <Box sx={{ minWidth: '120px', display: 'flex', alignItems: 'center' }}>
                    {renderEndDateFilter()}
                  </Box>
                }
              </Box>
              
              {/* Indicador visual de desborde a la derecha */}
              {(showScrollIndicator && !isLotoWorkflow) && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '16px',
                    bottom: '8px',
                    right: 0,
                    width: '40px',
                    background: 'linear-gradient(to right, transparent, rgba(255,255,255,1))',
                    pointerEvents: 'none',
                    zIndex: 2,
                    transition: 'opacity 0.2s',
                  }}
                />
              )}
            </Box>

            {/* Fila 2: Botones de acción alineados e items Loto si aplica */}
            <Grid container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 10, lg: 16, xl: 10 }}
              alignItems="center"
            >
                {renderCreateFlowButton() && (
									<>
										<Grid item xs={6} sm={3}>
											{renderCreateFlowButton()}
										</Grid>
										{isLotoWorkflow && <Grid item xs={2} sm={3}/>}
									</>
                )}
                {isLotoWorkflow && (
                  <>
                    <Grid item xs={6} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      {renderStatusCanceledSwitch()}
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      {renderStatusClosedSwitch()}
                    </Grid>
                  </>
                )}
	              <Grid item xs={isLotoWorkflow ? 12 : 6} sm={isLotoWorkflow ? 6 : 6} sx={{ display: 'flex', justifyContent: isLotoWorkflow ? 'flex-end' : 'flex-start' }}>
                  {renderSearchAndCleanButtons()}
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Grid container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 10, lg: 16, xl: 10 }}
          >
            {renderCreateFlowButton() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderCreateFlowButton()}
              </Grid>
            )}
            {renderOnlyActiveSwitch() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderOnlyActiveSwitch()}
              </Grid>
            )}
            {renderStatusCanceledSwitch() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderStatusCanceledSwitch()}
              </Grid>
            )}
            {renderStatusClosedSwitch() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderStatusClosedSwitch()}
              </Grid>
            )}
            {renderPlantsFilter() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderPlantsFilter()}
              </Grid>
            )}
            {renderStatusFilter() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderStatusFilter()}
              </Grid>
            )}
            {renderCompanyFilter() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderCompanyFilter()}
              </Grid>
            )}
            {renderStartDateFilter() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderStartDateFilter()}
              </Grid>
            )}
            {renderEndDateFilter() && (
              <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                {renderEndDateFilter()}
              </Grid>
            )}
            <Grid item xs={6} sm={4} md={4} lg={4} xl={2}>
              {renderSearchAndCleanButtons()}
            </Grid>
          </Grid>
        )}
      </Forms>
    </CustomToolbar>
  );
};
